module.exports = __webpack_public_path__ + "media/icons/close-icon-8f48d15e.svg";